import { Typography } from '@arionbanki/arionui';
import { FLOW_TYPE } from 'consts/flows';
import { AppContext } from 'providers/AppContext';
import { useContext } from 'react';
import { RiskqTextRRSURow } from './RiskqTextRRSURow';

const RRSU_PREFIX = `${FLOW_TYPE.RR_SU}_riskq`;

const RRSU_KEYS = [1, 2, 3].map(i => ({
	title: `${RRSU_PREFIX}_title_${i}`,
	text: `${RRSU_PREFIX}_text_${i}`
}));

export function RiskqTextRRSU() {
	const { t } = useContext(AppContext);
	return (
		<>
			<Typography TagName="p">{t(`${RRSU_PREFIX}_text`, 'riskq')}</Typography>
			{RRSU_KEYS.map(RiskqTextRRSURow)}
			<Typography className="mb-5" TagName="p">
				{t(`${RRSU_PREFIX}_description`, 'riskq')}
			</Typography>
		</>
	);
}
